import $$ from 'cmn-utils'

const baseUrl = "/api/device/other-action/";
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
}